import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {WpService} from '../../../../services/wp.service';
import {UrlBuilderService} from '../../../../services/url-builder.service';
import {WPPostBlog} from '../../../../types/WPPostBlog';
import {MediaSizeEnum} from '../../../../enums/WPEnums';
import {WPTag} from '../../../../types/WPTag';
import {ToolsService} from '../../../../services/tools.service';

@Component({
  selector: 'app-blog-list-article',
  templateUrl: './blog-list-article.component.html',
  styleUrls: ['./blog-list-article.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogListArticleComponent implements OnInit {
  @Input() blogPost: WPPostBlog;
  @Input() tags: WPTag[];
  @Input() index: number;
  public routePath: string[];
  public hasImage: boolean;
  public publishDate: string;
  public mediaSizeEnum = MediaSizeEnum;
  public postTags: WPTag[];
  public postTagsString: string = '';
  public titleCssClass: string;
  public btnCssClass: string;
  public imgCssClass: string;

  constructor(
    private wpService: WpService,
    private urlBuilder: UrlBuilderService,
    private tools: ToolsService
  ) {}

  ngOnInit() {
    this.filterTags();
    this.routePath = this.urlBuilder.CreateBlogPostRouterLink(
      this.blogPost.id,
      decodeURI(this.blogPost.slug)
    );
    this.hasImage = this.blogPost && this.blogPost.featured_media > 0;
    this.publishDate = this.wpService.getFormattedDate(this.blogPost.date);
    this.setElCssClasses();
  }

  private filterTags(): void {
    this.postTags = [];
    const tagsStr: string[] = [];
    this.blogPost.blogtag.forEach((tagId) => {
      const wpTag: WPTag = this.wpService.getTagById(tagId, this.tags);
      if (!this.tools.isNil(wpTag)) {
        this.postTags.push(wpTag);
        tagsStr.push(wpTag.name);
      }
    });
    this.postTagsString = ' | ' + tagsStr.join(', ');
  }

  private setElCssClasses(): void {
    this.btnCssClass = !this.tools.isNil(this.index)
      ? `test-blog-post-morebtn-${this.index}`
      : `test-blog-post-morebtn`;
    this.titleCssClass = !this.tools.isNil(this.index)
      ? `test-blog-post-title-${this.index}`
      : `test-blog-post-title`;
    this.imgCssClass = !this.tools.isNil(this.index)
      ? `test-blog-post-img-link-${this.index}`
      : `test-blog-post-img-link`;
  }
}
